import { CustomCardColorBar, CustomPanel, PageHeader, PontuacaoCard } from '../../../../components'
import React from 'react'
import { azul, error, laranja } from '../../../../assets/js/colors'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { withRouter } from 'react-router-dom'

function EtapaPicking({ history }) {
  const etapaPickingInfo = history.location.state.etapa_picking_info

  const {
    picking_por_empresa,
    lista_ciclos_pendentes_para_picking,
    tp_name,
    pontuacao_total,
    pontuacao_obtida,
  } = etapaPickingInfo

  // Helpers
  const getQtePickingRealizadoTotal = () => {
    return picking_por_empresa.length > 0
      ? picking_por_empresa.reduce((total, item) => {
          return total + item.qte_picking_codigo_barra + item.qte_picking_manual
        }, 0)
      : '-'
  }

  const getQtePickingCodigoBarra = () => {
    return picking_por_empresa.length > 0
      ? picking_por_empresa.reduce((total, item) => {
          return total + item.qte_picking_codigo_barra
        }, 0)
      : '-'
  }

  const getQtePickingManual = () => {
    return picking_por_empresa.length > 0
      ? picking_por_empresa.reduce((total, item) => {
          return total + item.qte_picking_manual
        }, 0)
      : '-'
  }

  // Render
  return (
    <>
      <PageHeader>
        Status Operação - &nbsp; <strong>Etapa Picking</strong>
      </PageHeader>
      <div style={{ marginTop: 16 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-9">
              <h2>{tp_name}</h2>
            </div>
            <div className="p-col-3">
              <PontuacaoCard pontuacaoTotal={pontuacao_total} pontuacaoObtida={pontuacao_obtida} />
            </div>
            <div className="p-col-12">
              <PickingRealizados
                pickingsRealizado={picking_por_empresa}
                qteTotal={getQtePickingRealizadoTotal()}
                qteCodigoBarra={getQtePickingCodigoBarra()}
                qteManual={getQtePickingManual()}
              />
            </div>
            <div className="p-col-12">
              <ListaCiclosPendentesParaPicking
                listaCiclosPendentes={lista_ciclos_pendentes_para_picking}
              />
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

function PickingRealizados({ qteTotal, qteCodigoBarra, qteManual, pickingsRealizado }) {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <PageHeader>Picking Realizados</PageHeader>
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={azul}
          value={qteTotal}
          title={'Qte Pickings Realizado'}
          subTitle={'Código de Barra + Manual'}
        />
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={error}
          value={qteCodigoBarra}
          title={'Código de Barra'}
          subTitle={'Leitor Código de Barra'}
        />
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={laranja}
          value={qteManual}
          title={'Manual'}
          subTitle={'Guia de Separação'}
        />
      </div>
      <div className="p-col-12">
        <DataTable value={pickingsRealizado} rows={5} paginator={true}>
          <Column field={'empresa'} header={'Empresa'} />
          <Column
            field={'qte_picking_codigo_barra'}
            header={'Código de Barra'}
            style={tableCellCentered(150)}
          />
          <Column field={'qte_picking_manual'} header={'Manual'} style={tableCellCentered()} />
        </DataTable>
      </div>
    </div>
  )
}

function ListaCiclosPendentesParaPicking({ listaCiclosPendentes }) {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <PageHeader>Lista de Ciclos Pendentes para Picking</PageHeader>
      </div>
      <div className="p-col-4">
        <CustomCardColorBar
          barColor={azul}
          value={listaCiclosPendentes.reduce((total, item) => total + item.qte_ciclos_pendentes, 0)}
          title={'Qte Ciclos Pendentes'}
          subTitle={'Ciclos de Entregas não separados'}
        />
      </div>
      <div className="p-col-12">
        <DataTable value={listaCiclosPendentes} rows={5} paginator={true}>
          <Column field={'empresa'} header={'Empresa'} style={{ width: 200 }} />
          <Column field={'qte_ciclos_pendentes'} header={'Quant.'} style={tableCellCentered()} />
          <Column field={'deadlines'} header={'Data Importação'} />
        </DataTable>
      </div>
    </div>
  )
}

export default withRouter(EtapaPicking)
